<template>
    <div class="disable-dbl-tap-zoom" style="width: 100%; height: 100%;">
        <video id="video" @ended="onVideoEnd" @click.prevent="onVideoClick" class="game-video">
            <source :src="settings.url" type="video/mp4">
         </video>
         <br/>
         <span class="debug-statusbar">Correct: {{correctHits}}<br/>Incorrect: {{incorrectHits}}</span>
         <div v-show="videoEnded" class="score-container">
            <h3>Score</h3>
            <p class="score-value">{{calculateScore()}}</p>
         </div>
    </div>
</template>

<script>
export default {
    'props': {
        data: {}
    },
    data: function() {
        return {
            settings: {
                targetSections: [
                    {id: 0, begin: 11, end: 12, clicked: false},
                ],
                incorrectPenalty: 0.1,
                url: this.data[0].question.video,
            },
            correctHits: 0,
            incorrectHits: 0,
            videoEl: null,
            videoEnded: false,
        }
    },
    methods: {
        onVideoClick: function() {
            if(this.videoEnded) {
                return;
            }

            if(this.videoEl.paused) {
                this.videoEl.play();
                return;
            }

            console.log(this.videoEl.currentTime);
            let hitSections = this.settings.targetSections.filter((section) => {
                if(this.videoEl.currentTime >= section.begin && this.videoEl.currentTime <= section.end) {
                    return true;
                }

                return false;
            });

            if(hitSections && hitSections.length > 0) {
                hitSections.forEach((elem) => {
                    if(elem.clicked == false) {
                        this.correctHits++;
                    }
                    elem.clicked = true;
                });
            } else {
                this.incorrectHits++;
            }
        },
        onVideoEnd: function() {
            console.log('video end');
            this.videoEnded = true;
        },
        calculateScore: function() {
            let correct = this.correctHits / this.settings.targetSections.length;
            let penalty = this.settings.incorrectPenalty * this.incorrectHits;
            let result = correct - penalty;
            result = Math.round(100 * Math.max(result, 0));

            console.log('Score:', correct, penalty, result);
            return result;
        }
    },
    mounted() {
        this.videoEl = document.getElementById('video');
    }
}
</script>